// 版本号应该与 package.json 中的版本保持同步
export const SDK_VERSION = '1.20.4';
export const SDK_NAME = 'sentry.javascript.miniapp';
